import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { PRODUCT_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class ProjectNamesService {
    private readonly URL_PATH = `${PRODUCT_URL}/projectNames`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public getAllProjectNames(params: {
        pageIndex: number;
        pageSize: number;
        searchValue: string;
        countryIds?: number[];
    }): Observable<any> {
        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize);
        if (params.searchValue && params.searchValue !== '') {
            queryParams = queryParams.set('searchValue', params.searchValue.trim());
        }
        if (params.countryIds?.length) {
            queryParams = queryParams.set('countryIds', params.countryIds.join(','));
        }
        return this.http
            .get<any>(`${this.URL_PATH}/getAllProjectNames`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public addProjectNames(data: { name: string; countryId: number }): Observable<any> {
        return this.http
            .post<any>(`${this.URL_PATH}/save`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public updateProjectNames(data: { id: number; name: string; countryId?: number }): Observable<any> {
        return this.http
            .post<any>(`${this.URL_PATH}/updateProjectNames`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public deleteProjectNames(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.URL_PATH}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }
}
